import React from 'react';
import { useTranslation } from 'react-i18next';

export function TickerBar({ wsData, connected }) {
  const { t } = useTranslation();
  if (!wsData || wsData.type !== 'price_update') return null;
  const allPrices = [
    ...Object.entries(wsData.crypto || {}).map(([k, v]) => ({ symbol: k, ...v, type: 'crypto' })),
    ...Object.entries(wsData.equities || {}).map(([k, v]) => ({ symbol: k, ...v, type: 'equity' })),
  ];

  return (
    <div className="bg-[#090B0F] border-b border-white/[0.06] overflow-hidden" data-testid="ticker-bar">
      <div className="flex items-center gap-6 px-4 py-1.5 animate-[scroll_30s_linear_infinite] whitespace-nowrap">
        {allPrices.map(p => (
          <span key={p.symbol} className="inline-flex items-center gap-2 text-xs font-mono">
            <span className="text-slate-500">{p.symbol}</span>
            <span className="text-white">${typeof p.price === 'number' ? p.price.toFixed(p.price > 100 ? 2 : 4) : p.price}</span>
            <span className={`${(p.change_24h ?? 0) >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
              {(p.change_24h ?? 0) >= 0 ? '+' : ''}{(p.change_24h ?? 0).toFixed(2)}%
            </span>
          </span>
        ))}
        {connected && <span className="text-emerald-500 text-[10px]">{t('dashboard.wsLive')}</span>}
      </div>
    </div>
  );
}
